// extracted by mini-css-extract-plugin
module.exports = {" _key":"sitepen-site/UIDesign","root":"UIDesign-m__root__f52bc32fYcR Development-m__root__f52bc3Ph59M","nowrap":"UIDesign-m__nowrap__f52bc33UTzE"};